/* Plock-A11y: additive Barrierefreiheits-Patches (BFSG/WCAG), gefunden per axe-core-Audit
   (Sept/Okt 2026). WICHTIG: rein additiv und rein clientseitig - aendert NICHTS an
   bestehender Funktionalitaet, Klick-Handlern, Markup-Struktur oder Layout. Ergaenzt nur
   fehlende ARIA-Attribute/Alt-Texte bzw. korrigiert ungueltige ARIA-Attribute, die von den
   nativen Shopify-Theme-Komponenten (Slideshow, Produktkarten-Buy-Buttons, Hero, Warenkorb)
   ausgehen oder durch eigene Plock-Erweiterungen entstanden sind.

   Behebt:
   1) button-name: Add-to-Cart-Buttons auf Produktkarten bekommen IMMER ein aria-label,
      unabhaengig davon ob ihr Textinhalt im DOM vorhanden ist - in manchen Karussell-/
      Kachel-Kontexten ist der Button-Text zwar im DOM vorhanden, aber per CSS visuell
      verborgen (z.B. sr-only-aehnliche Klassen), wodurch er fuer axe-core/Screenreader
      trotzdem als "kein zugaenglicher Name" gilt. Ein zusaetzliches aria-label schadet nicht
      (identischer Text) und behebt das zuverlaessig in allen Faellen.
   2) aria-allowed-attr: Slideshow-Dot-Buttons setzen aria-selected (auf <button> nicht
      erlaubt) - wird gespiegelt auf aria-current und entfernt.
   3) aria-hidden-focus: Nicht sichtbare Karussell-Folien (aria-hidden="true") duerfen keine
      fokussierbaren Kind-Elemente enthalten - deren tabindex wird auf -1 gesetzt, solange sie
      verborgen sind, und beim Sichtbarwerden wiederhergestellt.
   4) image-alt: Hero-Bild ohne alt-Attribut bekommt alt="" (dekorativ, da der eigentliche
      Hero-Text als separater Textblock vorhanden ist).
   5) link-name: Bild-Link-Bloecke und Warenkorb-Produktbild-Links ohne zugaenglichen Text
      bekommen ein aria-label. */
(function () {
  function fixAddToCartButtonNames(root) {
    (root || document).querySelectorAll('button[data-testid="standalone-add-to-cart"]').forEach(function (btn) {
      if (btn.hasAttribute('aria-label') || btn.hasAttribute('aria-labelledby')) return;
      btn.setAttribute('aria-label', 'In den Warenkorb legen');
    });
  }

  function fixSlideshowDots(root) {
    (root || document).querySelectorAll('.slideshow-control[aria-selected]').forEach(function (dot) {
      var selected = dot.getAttribute('aria-selected');
      dot.setAttribute('aria-current', selected === 'true' ? 'true' : 'false');
      dot.removeAttribute('aria-selected');
    });
  }

  function fixHeroAlt(root) {
    (root || document).querySelectorAll('img.hero__media:not([alt]), .hero__media img:not([alt])').forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  function fixEmptyLinkNames(root) {
    (root || document).querySelectorAll('a.image-block[href="/collections/koerperhygiene"]').forEach(function (a) {
      if (a.hasAttribute('aria-label') || a.hasAttribute('aria-labelledby')) return;
      var text = (a.textContent || '').trim();
      if (text.length > 0) return;
      a.setAttribute('aria-label', 'Zur Kategorie Körperhygiene');
    });

    (root || document).querySelectorAll('.cart-items__media-container').forEach(function (a) {
      if (a.hasAttribute('aria-label') || a.hasAttribute('aria-labelledby')) return;
      var text = (a.textContent || '').trim();
      if (text.length > 0) return;
      var img = a.querySelector('img');
      var alt = img && img.getAttribute('alt');
      a.setAttribute('aria-label', alt && alt.trim().length > 0 ? alt.trim() : 'Zum Produkt');
    });
  }

  var FOCUSABLE_SELECTOR = 'a[href], button, input, select, textarea, [tabindex]';

  function applyAriaHiddenFocusFix(el) {
    if (!el || el.nodeType !== 1 || !el.querySelectorAll) return;
    var hidden = el.getAttribute('aria-hidden') === 'true';
    var focusables = el.querySelectorAll(FOCUSABLE_SELECTOR);
    focusables.forEach(function (node) {
      if (hidden) {
        if (!node.hasAttribute('data-plock-prev-tabindex')) {
          node.setAttribute('data-plock-prev-tabindex', node.getAttribute('tabindex') || '');
        }
        node.setAttribute('tabindex', '-1');
      } else if (node.hasAttribute('data-plock-prev-tabindex')) {
        var prev = node.getAttribute('data-plock-prev-tabindex');
        if (prev) {
          node.setAttribute('tabindex', prev);
        } else {
          node.removeAttribute('tabindex');
        }
        node.removeAttribute('data-plock-prev-tabindex');
      }
    });
  }

  function scanAriaHidden(root) {
    (root || document).querySelectorAll('[aria-hidden="true"]').forEach(applyAriaHiddenFocusFix);
  }

  function runAll(root) {
    fixAddToCartButtonNames(root);
    fixSlideshowDots(root);
    fixHeroAlt(root);
    fixEmptyLinkNames(root);
    scanAriaHidden(root);
  }

  function init() {
    runAll(document);

    var observer = new MutationObserver(function (mutations) {
      var needsFullRescan = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          applyAriaHiddenFocusFix(mutation.target);
        } else if (mutation.type === 'attributes' && mutation.attributeName === 'aria-selected') {
          fixSlideshowDots(document);
        } else if (mutation.type === 'childList') {
          needsFullRescan = true;
        }
      });
      if (needsFullRescan) runAll(document);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'aria-selected']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
